module.exports = __webpack_public_path__ + "static/pershing-hologram-c834097e697e95e58570bef5373a17e8.jpg";